import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { FaEdit } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { selectAuth, setActiveTab } from "../../redux/features/authSlice";
import { IAuthUser } from "../../redux/features/authSlice/authSlice.types";
import jwt_decode from "jwt-decode";
import CustomLoading from "../../components/CustomLoading";
import CustomModal from "../../components/CustomModal";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import CustomInput from "../../components/CustomInput";
import {
    useGetProfileQuery,
    useUpdateProfileMutation,
} from "../../redux/api/profileApi/profileApi";
import { useDeleteMerchantMutation, useGetOperatorListQuery } from "../../redux/api/merchantApi/merchantApi";
import { AiOutlineDelete } from "react-icons/ai";
import { useCreateMerchantMutation } from "../../redux/api/authApi/authApi";
import CustomSwitchButton from "../../components/CustomSwitchButton";

const storePermissionList = [
    {
        title: 'Store List',
        value: 'StoreList',
    },
    {
        title: 'Create Store',
        value: 'CreateStore',
    },
    {
        title: 'Update Store',
        value: 'UpdateStore',
    },
    {
        title: 'Remove Store',
        value: 'RemoveStore',
    },
]

const parcelPermissionList = [
    {
        title: 'Pickup Request',
        value: 'PickupRequest',
    },
    {
        title: 'Create Parcel',
        value: 'CreateParcel',
    },
    {
        title: 'Update Parcel',
        value: 'UpdateParcel',
    },
    {
        title: 'List Parcel',
        value: 'ListParcel',
    },
    {
        title: 'Export Parcel List',
        value: 'ExportParcelList',
    },
]

const paymentPermissionList = [
    {
        title: 'Wallet Information',
        value: 'WalletInformation',
    },
    {
        title: 'Payment Rerquest',
        value: 'PaymentRerquest',
    },
    {
        title: 'Invoice List',
        value: 'InvoiceList',
    },
    {
        title: 'List Parcel',
        value: 'ListParcel',
    },
    {
        title: 'Download Invoice List',
        value: 'DownloadInvoiceList',
    },
]

const orderPermissionList = [
    {
        title: 'Order Tracking',
        value: 'OrderTracking',
    },
]

const ManageOperator = () => {
    const { token } = useSelector(selectAuth);
    const authData: IAuthUser = token ? jwt_decode(token) : null;
    const { data: profileData, isLoading: profileLoading } = useGetProfileQuery(
        authData?.id
    );
    const permissions: string[] = profileData?.permissions
        ? JSON.parse(profileData?.permissions)
        : [];
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const [filterText, setFilterText] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [operatorInfo, setOperatorInfo] = useState(null);
    const [operatorId, setOperatorId] = useState(null);
    const [operatorStatus, setOperatorStatus] = useState("Active");
    const { data: operatorList, isLoading: operatorListLoading } =
        useGetOperatorListQuery(profileData?.id);
    console.log(operatorList)
    const [operators, setOperators] = useState([]);
    const [updateOperator, updateResult] = useUpdateProfileMutation();
    const [createOperator, createResult] = useCreateMerchantMutation();
    const [operatorPermissions, setOperatorPermissions] = useState([]);
    const [deleteOperator, deleteResult] = useDeleteMerchantMutation();

    const columns = [
        {
            name: "Name",
            selector: (row) => row?.name,
            sortable: true,
        },
        {
            name: "Email",
            selector: (row) => row?.email,
            sortable: true,
        },
        {
            name: "Phone",
            selector: (row) => row?.contact_number,
            sortable: true,
        },
        {
            name: "Status",
            selector: (row) => (
                <div
                    className={`py-1 w-20 text-center rounded ${row?.isActive
                        ? "bg-success/10 text-success"
                        : "bg-attention/10 text-attention"
                        }`}
                >
                    {row?.isActive ? "Active" : "Inactive"}
                </div>
            ),
            sortable: true,
        },
        {
            name: "Edit",
            cell: (row) => (
                <div
                    onClick={() => {
                        if (permissions?.includes("EditOperator")) {
                            setOperatorInfo(row);
                            setShowModal(true);
                        } else {
                            toast.info("You have not permitted!");
                        }
                    }}
                    className={`flex flex-row gap-2 items-center justify-center py-1 w-20 text-center rounded border bg-secondary/10 border-secondary text-secondary cursor-pointer transition-all hover:bg-secondary hover:animate-pulse hover:text-white`}
                >
                    <FaEdit /> Edit
                </div>
            ),
        },
        {
            name: "Delete",
            cell: (row) => (
                <div
                    onClick={() => {
                        if (permissions?.includes("DeleteOperator")) {
                            setOperatorId(row?.id);
                            setDeleteModal(true);
                        } else {
                            toast.info("You have not permitted!");
                        }
                    }}
                    className={`flex flex-row gap-2 items-center justify-center py-1 w-20 text-center rounded border bg-warning/10 border-warning text-warning cursor-pointer transition-all hover:bg-warning hover:animate-pulse hover:text-white`}
                >
                    <AiOutlineDelete /> Delete
                </div>
            ),
        },
    ];

    const handlePermissionCheck = (permission) => {
        if (operatorPermissions?.includes(permission)) {
            const newPermissions = operatorPermissions?.filter((per) => per !== permission);
            setOperatorPermissions(newPermissions);
        } else {
            setOperatorPermissions([...operatorPermissions, permission]);
        }
    };

    const filteredOperators = operators
        ?.filter(
            (item) =>
                item.name && item.name.toLowerCase().includes(filterText.toLowerCase())
        )
        ?.reverse();

    const validationSchema1 = Yup.object().shape({
        name: Yup.string().required("Name is required"),
        email: Yup.string().required("Email is required"),
        phone: Yup.string().required("Phone number is required"),
        password: Yup.string()
            .min(6, "At least 6 characters")
            .required("Password is required"),
    });
    const validationSchema2 = Yup.object().shape({
        name: Yup.string().required("Name is required"),
        phone: Yup.string().required("Phone number is required"),
    });

    const initialValues = {
        name: "",
        email: "",
        phone: "",
        password: "",
    };


    const formik = useFormik({
        initialValues,
        validationSchema: operatorInfo ? validationSchema2 : validationSchema1,
        onSubmit: async (values, { resetForm }) => {
            const createData = {
                name: values?.name,
                email: values?.email,
                password: values?.password,
                password_confirm: values?.password,
                company_name: profileData?.company_name,
                address: profileData?.address,
                contact_number: values?.phone,
                branch_id: profileData?.branch?.id,
                parent_merchant_id: profileData?.id,
            };
            const updateData = {
                name: values?.name,
                contact_number: values?.phone,
                permissions: operatorPermissions,
                isActive: operatorStatus === 'Active' ? true : false,
            };
            try {
                if (operatorInfo) {
                    await updateOperator({ data: updateData, profileId: operatorId }).unwrap();
                    toast.success("Operator updated successfully!");
                } else {
                    const createdResult = await createOperator(createData).unwrap();
                    await updateOperator({ data: { permissions: operatorPermissions }, profileId: createdResult?.id }).unwrap();
                    toast.success("Operator created successfully!");
                }
                resetForm();
                setShowModal(false);
            } catch (error) {
                console.log(error);
                toast.error(error?.data?.message || "Something went wrong!");
            }
        },
    });

    const {
        handleSubmit,
        values,
        touched,
        errors,
        setFieldValue,
        handleBlur,
        resetForm,
    } = formik;

    const handleDeleteStore = async () => {
        try {
            if (operatorId) {
                await deleteOperator(operatorId);
                toast.success("Operator deleted successfully!");
            }
            setDeleteModal(false);
        } catch (error) {
            console.log(error);
            toast.error(error?.data?.message || "Something went wrong!");
        }
    }

    useEffect(() => {
        if (operatorInfo) {
            setFieldValue("name", operatorInfo?.name);
            setFieldValue("phone", operatorInfo?.contact_number);
            setOperatorId(operatorInfo?.id);
            setOperatorStatus(operatorInfo?.isActive ? "Active" : "Inactive");
            setOperatorPermissions(JSON.parse(operatorInfo?.permissions))
        }
    }, [operatorInfo]);

    useEffect(() => {
        if (operatorList) {
            const newList = operatorList?.filter(
                (op) =>
                    !op?.isManager
            );
            setOperators(newList);
        }
    }, [operatorList]);

    useEffect(() => {
        if (pathname === "/store-list") {
            dispatch(setActiveTab("Store List"));
        }
    }, [dispatch, pathname]);

    return (
        <div className="w-full flex flex-col gap-10">
            <div className="bg-white shadow-lg rounded-lg p-4 justify-between flex flex-row gap-10">
                <div className="flex flex-col justify-between w-full gap-4">
                    <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                        <div className="text-2xl font-bold text-text_1">Operator List</div>
                        <div
                            onClick={() => {
                                if (permissions?.includes("CreateOperator")) {
                                    resetForm();
                                    setShowModal(true);
                                    setOperatorInfo(null);
                                    setOperatorPermissions([]);
                                } else {
                                    toast.info("You have not permitted!");
                                }
                            }}
                            className="py-2 px-3 border border-secondary text-secondary rounded bg-secondary/10 flex items-center justify-center gap-2 cursor-pointer transition-all hover:bg-secondary hover:animate-pulse hover:text-white"
                        >
                            Add New Operator
                        </div>
                    </div>
                    <div className="flex flex-row gap-4 items-center w-full">
                        <input
                            type="text"
                            className="flex-grow p-2 w-full focus:ring-0 border-2 rounded-lg focus:border-secondary focus:outline-none"
                            placeholder={`Search by operator name`}
                            onChange={(e) => setFilterText(e.target.value)}
                            value={filterText}
                        />
                        <button
                            disabled={!filterText}
                            onClick={() => setFilterText("")}
                            className={`py-2 w-24 text-center border border-warning text-warning rounded bg-warning/10 flex items-center justify-center ${!filterText
                                ? ""
                                : "cursor-pointer transition-all hover:bg-warning hover:animate-pulse hover:text-white"
                                }`}
                        >
                            Clear
                        </button>
                    </div>
                </div>
                <div className="h-40 hidden lg:flex">
                    <img
                        src="https://res.cloudinary.com/di23omfvx/image/upload/v1692428968/self_driving_car_Road_1_npjom3.gif"
                        alt="self drive"
                        className="h-full w-full"
                    />
                </div>
            </div>
            <div className="overflow-x-auto bg-white shadow-lg rounded-lg p-2">
                <DataTable
                    columns={columns}
                    data={filteredOperators}
                    pagination
                    persistTableHead
                    highlightOnHover
                />
            </div>

            <CustomModal
                showModal={showModal}
                setShowModal={setShowModal}
                submitButton={true}
                handleSubmit={handleSubmit}
                title={operatorInfo ? "Update Operator Info" : "Add New Operator"}
            >
                <form
                    onSubmit={handleSubmit}
                    className="w-full flex flex-col gap-2 mt-5 min-w-[70%]"
                >
                    <div className="flex flex-col sm:flex-row gap-5">
                        <CustomInput
                            label="NAME"
                            type="text"
                            setFieldValue={setFieldValue}
                            value={values.name}
                            touched={touched.name}
                            error={errors.name}
                            handleBlur={handleBlur}
                        />
                        <CustomInput
                            label="PHONE"
                            type="number"
                            setFieldValue={setFieldValue}
                            value={values.phone}
                            touched={touched.phone}
                            error={errors.phone}
                            handleBlur={handleBlur}
                        />
                    </div>
                    {!operatorInfo && (
                        <div className="flex flex-col sm:flex-row gap-5">
                            <CustomInput
                                label="EMAIL"
                                type="email"
                                setFieldValue={setFieldValue}
                                value={values.email}
                                touched={touched.email}
                                error={errors.email}
                                handleBlur={handleBlur}
                            />
                            <CustomInput
                                label="PASSWORD"
                                type="password"
                                setFieldValue={setFieldValue}
                                value={values.password}
                                touched={touched.password}
                                error={errors.password}
                                handleBlur={handleBlur}
                            />
                        </div>
                    )}
                    {operatorInfo && (
                        <div className="w-full mt-2">
                            <div className="text-text_2 text-md font-semibold mb-2">
                                SELECT OPERATOR STATUS
                            </div>
                            <select
                                id="status"
                                value={operatorStatus}
                                onChange={(e) => setOperatorStatus(e.target.value)}
                                className="w-full border-2 p-2 rounded-lg focus:outline-none focus:border-secondary"
                            >
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                        </div>
                    )}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
                        <div className="bg-[#22B7F233] rounded-lg p-4">
                            <div className="text-xl text-text_1 font-semibold mb-3">Store Permissions</div>
                            {
                                storePermissionList?.map((permission, index) => {
                                    return (
                                        <div key={index}>
                                            <CustomSwitchButton
                                                checked={operatorPermissions?.includes(permission?.value)}
                                                title={permission?.title}
                                                onChange={() => handlePermissionCheck(permission?.value)}
                                            />
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className="bg-[#00E60033] rounded-lg p-4">
                            <div className="text-xl text-text_1 font-semibold mb-3">Parcel Permissions</div>
                            {
                                parcelPermissionList?.map((permission, index) => {
                                    return (
                                        <div key={index}>
                                            <CustomSwitchButton
                                                checked={operatorPermissions?.includes(permission?.value)}
                                                title={permission?.title}
                                                onChange={() => handlePermissionCheck(permission?.value)}
                                            />
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className="bg-[#FFCE0D33] rounded-lg p-4">
                            <div className="text-xl text-text_1 font-semibold mb-3">Payment Permissions</div>
                            {
                                paymentPermissionList?.map((permission, index) => {
                                    return (
                                        <div key={index}>
                                            <CustomSwitchButton
                                                checked={operatorPermissions?.includes(permission?.value)}
                                                title={permission?.title}
                                                onChange={() => handlePermissionCheck(permission?.value)}
                                            />
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className="bg-[#F2AE3033] rounded-lg p-4">
                            <div className="text-xl text-text_1 font-semibold mb-3">Order Permissions</div>
                            {
                                orderPermissionList?.map((permission, index) => {
                                    return (
                                        <div key={index}>
                                            <CustomSwitchButton
                                                checked={operatorPermissions?.includes(permission?.value)}
                                                title={permission?.title}
                                                onChange={() => handlePermissionCheck(permission?.value)}
                                            />
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </form>
            </CustomModal>

            <CustomModal
                showModal={deleteModal}
                setShowModal={setDeleteModal}
                submitButton={true}
                handleSubmit={handleDeleteStore}
                title={'Deleting Process'}
                submitButtonText='Yes'
                closeButtonText="No"
                className="sm:min-w-[70%] md:min-w-[60%] lg:min-w-[25vw] xl:min-w-[20vw]"
            >
                <div className="text-lg text-warning ">Do you want to delete this operator ?</div>
            </CustomModal>

            {(createResult.isLoading ||
                updateResult.isLoading ||
                profileLoading ||
                operatorListLoading || deleteResult?.isLoading) && <CustomLoading />}
        </div>
    );
};

export default ManageOperator;
